import { Typography, ListItem, ListItemText, Skeleton } from '@mui/material'
import { useGetAuthUser } from '@/service-library/hooks/auth-user'
import { LogEntry } from '@/types/log-entries'
import { prettifyDate } from '@/utils/time'
import EntryLongDescription from './EntryLongDescription'

type DocumentLogEntriesProps = {
  logEntry: LogEntry
}

export default function DocumentLogEntry({
  logEntry,
}: DocumentLogEntriesProps) {
  const { created_at, user_id, origin_name } = logEntry
  const { user, isPending } = useGetAuthUser({
    id: user_id || '',
    staleTime: Infinity,
    enabled: !origin_name,
  })

  return (
    <ListItem alignItems="flex-start" disablePadding>
      <ListItemText
        primary={
          <>
            {user_id && !origin_name && isPending ? (
              <Skeleton width={100} sx={{ display: 'inline-block' }} />
            ) : (
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'text.primary', display: 'inline' }}
              >
                <b>{origin_name || user?.name || 'System'}</b>
              </Typography>
            )}
            <Typography variant="caption">
              {' - '}
              <Typography color="text.secondary" variant="caption">
                {prettifyDate(created_at)}
                {' - '}
              </Typography>
              <EntryLongDescription {...logEntry} />
            </Typography>
          </>
        }
        slotProps={{
          primary: {
            component: 'p',
            sx: {
              lineHeight: 1,
            },
          },
        }}
        sx={{ my: '2px' }}
      />
    </ListItem>
  )
}
